<template>
    <v-card>
        <v-card-text fluid>
            <v-data-table :headers="dTable.headers" :items="dTlfAlumnos" :loading="dTable.loading" class="elevation-1" hide-default-footer>
                <template v-slot:no-data>
                    <v-alert :value="true" type="warning" text border="top">
                        <strong>No hay registros para mostrar.</strong>
                    </v-alert>
                </template>
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>CONTACTOS TELEFÓNICOS</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical ></v-divider>
                        <v-btn color="primary" @click="fuModal()"><v-icon>add</v-icon> Agregar</v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon @click="fuModal(item)" title="Editar">edit</v-icon>
                    <v-icon @click="fuModalDelete(item.IdTelefono)" title="Eliminar">delete</v-icon>
                </template>
            </v-data-table>
        </v-card-text>
        <v-navigation-drawer
            v-model="dModal.dialog"
            right
            temporary
            fixed
            width="400"
        >
            <v-list-item class="text-h5 blue-grey" dark>
                <v-list-item-content>
                    <v-list-item-title class="text-h6">Contacto Telefónico</v-list-item-title>
                </v-list-item-content>                
                <v-btn icon @click="dModal.dialog = false"><v-icon>close</v-icon></v-btn>
            </v-list-item>
            <v-divider></v-divider>
            <div class="pa-2">
                <v-form ref="refModal" v-if="dTlfAlumno">
                    <v-row dense>
                        <v-col cols="12">
                            <v-select v-model="dTlfAlumno.IdRef" label="* Referencia" filled
                                :items="dTlfRefs"
                                item-value="IdRef" item-text="Referencia"
                                :rules="[v => !!v || 'El campo es requerido']">
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="dTlfAlumno.IdTipo1" label="* Tipo" filled
                                :items="dTlfTipos"
                                item-value="IdTipo" item-text="Descripcion"
                                :rules="[v => !!v || 'El campo es requerido']">
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="dTlfAlumno.Telefono1" label="* Nro Telefónico" filled dense :rules="[v => !!v || 'El campo es requerido']" :maxlength="10" autocomplete="off"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="dTlfAlumno.Observacion" label="Observación" filled dense rows="2" :maxlength="150" autocomplete="off"></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-btn @click="fuModalSave" color="primary" block><v-icon>save</v-icon> Guardar</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
                    <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
                </v-snackbar>
            </div>
        </v-navigation-drawer>
    </v-card>
</template>
<script>
import gql from 'graphql-tag';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
    name: 'TlfAlumno',
    props: {
        pIdAlumno: {
            type: Number,
            required: true,
        }
    },
    mounted(){
        if (this.pIdAlumno)
            this.fuLoad();
    },
    data: () => ({
        dModal: {
            dialog: false,
            loading: false,
        },
        dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'Referencia', text: 'Referencia'},
                {value: 'tlftipo.Descripcion', text: 'Tipo'},
                {value: 'Telefono1', text: 'Telefono'},
                {value: 'Observacion', text: 'Observacion'},
            ],
            loading: false,
        },
        dTlfAlumno: null,
        dTlfAlumnos: [],
        dTlfTipos: [],
        dTlfRefs: [],
        dSnackbar: false,
    }),
    methods: {
        async fuLoad() {
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query tlfalumnoByIdAlumno($IdAlumno: ID!, $Estado: Boolean!){
                        tlfalumnoByIdAlumnoByEstado(IdAlumno:$IdAlumno, Estado: $Estado){
                            IdTelefono
                            IdRef
                            Referencia
                            IdTipo1
                            Telefono1
                            Observacion
                            tlftipo{
                                Descripcion
                            }
                        }
                        tlftipoByEstado(Estado: $Estado){
                            IdTipo
                            Descripcion
                        }
                        tlfrefByEstado(Estado: $Estado){
                            IdRef
                            Referencia
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: this.pIdAlumno,
                        Estado: true
                    }
                })
                this.dTlfAlumnos = response.data.tlfalumnoByIdAlumnoByEstado;
                this.dTlfTipos = response.data.tlftipoByEstado;
                this.dTlfRefs = response.data.tlfrefByEstado;
            } catch (error) {
                console.log(error);
            } finally {
                this.dTable.loading = false;
            }
        },
        fuModal(p_Item){
            this.dModal.dialog = true;
            this.dTlfAlumno = {
                IdAlumno: this.pIdAlumno,
                IdRef: '',
                Referencia: '',
                IdTipo1: null,
                Telefono1: '',
                Estado: true,
                IdVisita: null,
                Observacion: ''
            };
            if (p_Item)
                this.dTlfAlumno = { ...p_Item };
        },
        fuModalSave(){
            if(!this.$refs.refModal.validate()){
                this.dSnackbar = true;
            } else {
                this.dTlfAlumno.Referencia = this.dTlfRefs.find(item => item.IdRef === this.dTlfAlumno.IdRef).Referencia;
                
                if(this.dTlfAlumno.IdTelefono)
                    this.fuUpdate(this.dTlfAlumno.IdTelefono);
                else
                    this.fuCreate();
            }
        },
        async fuCreate () {
            try {
                this.dModal.loading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation tlfalumnoCreate($input: tlfalumnoCreateInput!){
                        tlfalumnoCreate(input: $input){
                            IdTelefono
                        }
                    }`,
                    variables: {
                        input: this.dTlfAlumno
                    }
                });
                if(response.data){
                    this.fuLoad();
                    this.dModal.dialog = false;
                    Swal.fire('Correcto', 'Registro correcto.', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error')
            } finally {
                this.dModal.loading = false;
            }
        },
        async fuUpdate(p_IdTelefono) {
            try {
                this.dModal.loading = true;
                const { __typename, IdTelefono, tlftipo, ...vTlfAlumno } = this.dTlfAlumno;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation tlfalumnoUpdate($IdTelefono: ID!, $input: tlfalumnoUpdateInput!){
                        tlfalumnoUpdate(IdTelefono: $IdTelefono, input: $input){
                            IdTelefono
                        }
                    }`,
                    variables: {
                        IdTelefono: p_IdTelefono,
                        input: vTlfAlumno
                    }
                });
                if(response.data){
                    this.fuLoad();
                    this.dModal.dialog = false;
                    Swal.fire('Correcto', 'Registro correcto.', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error')
            } finally {
                this.dModal.loading = false;
            }
        },
        fuModalDelete(p_IdTelefono){
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                html: '<h3>Se va eliminar el registro.</h3>',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    this.fuDelete(p_IdTelefono);
                },
            }).then(() => {
            })
        },
        async fuDelete(p_IdTelefono) {
            try {
                this.dTable.loading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation tlfalumnoUpdate($IdTelefono: ID!, $input: tlfalumnoUpdateInput!){
                        tlfalumnoUpdate(IdTelefono: $IdTelefono, input: $input){
                            IdTelefono
                        }
                    }`,
                    variables: {
                        IdTelefono: p_IdTelefono,
                        input: {
                            Estado: false
                        }
                    }
                });
                if(response.data){
                    this.fuLoad();
                    Swal.fire('Correcto', 'Registro eliminado.', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'Registro no eliminado.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro no eliminado.', 'error')
            } finally {
                this.dTable.loading = false;
            }
        },
    }
}
</script>
<style scoped>
    .v-data-table tbody tr:nth-of-type(even) {
    background-color: #f5f5f5; /* Un gris muy claro */
    }

    .v-data-table tbody tr:nth-of-type(even):hover {
    background-color: #eeeeee !important;
    }
</style>
